import React, { useContext } from 'react';
import { Avatar,Box, Button, Grid, Typography, styled, useMediaQuery } from '@mui/material';
import { randomString as generateRandomString } from '../utils';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faArrowLeft, faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import theme from '../theme/theme';
import SelectAdvanced from './SelectAdvanced';
import { globalStore } from '../state/store';
import { updatePrediction } from '../services/predictionService';
import { CORRECTQUESTIONNAIRE } from '../assets/configs/constants';
import cp_dark from '../assets/img/cp_dark.png'


const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid` + theme.palette.grey[200],
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<FontAwesomeIcon icon={faCaretRight} 
    style={{ color: theme.palette.primary.main, fontSize: '13px', marginRight: '10px' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: '#fafafa',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid' + theme.palette.grey[200],
}));

export default function Questionnaire() {

  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  const [state, dispatch] = useContext(globalStore);
  const [expanded, setExpanded] = React.useState(null);

  const isCPAnswerSheet = Boolean(state.user) && state.user.uid === 'hyPRV6TXakMbalAtyb33uDFsOJb2';

  const handleAccordionChange = (panel) => {
    updatePrediction({ uid: state.user.uid, prediction: state.prediction });
    setExpanded(panel === expanded || panel === "qX" ? null : panel)
  };

  const handleChangeValue = (newVal) => {

    let pred = Boolean(state.prediction) ? 
                  state.prediction.filter((p) => p.stage === 'questionnaire' && p.qid === expanded)[0] :
                  []

    dispatch({
      type: Boolean(pred) && Boolean(pred._id) ? "UPDATE_PREDICTION" : "ADD_PREDICTION",
      payload: { 
        _id: Boolean(pred) && Boolean(pred._id) ? pred._id : generateRandomString(20),
        stage: 'questionnaire',
        qid: expanded,
        answer: /*Boolean(newVal) && Boolean(newVal._id) ? 
                    newVal._id : 
                Boolean(newVal) && Array.isArray(newVal) ? 
                    newVal : */
                Boolean(newVal) ?
                    newVal :
                    null,
      },
    })
  }

  return (
    <div>
        {state.questions.map((q, i) => {

            let answer =
                // All teams are possible and a team is selected
                q.answerOptions.includes('all-teams') &&
                Boolean(state.prediction) && 
                Boolean(state.prediction.filter((p) => p.stage === 'questionnaire' && p.qid === q.qid)[0]) &&
                Boolean(state.teams.filter((t) => t._id === state.prediction.filter((p) => p.stage === 'questionnaire' && p.qid === q.qid)[0].answer)[0]) ?
                    state.teams.filter((t) => t._id === state.prediction.filter((p) => p.stage === 'questionnaire' && p.qid === q.qid)[0].answer)[0] :
                isCPAnswerSheet && Boolean(state.prediction) && Boolean(state.prediction.filter((p) => p.stage === 'questionnaire' && p.qid === q.qid)[0]) ?
                    state.prediction.filter((p) => p.stage === 'questionnaire' && p.qid === q.qid)[0].answer :
                    null ;

            let answerAv =
                isCPAnswerSheet && Boolean(answer) ?
                    <Avatar src={cp_dark} sx={{width: '25px', height: '25px'}} /> :
                Boolean(answer) ? <Avatar src={answer.flag} sx={{width: '25px', height: '25px'}} /> : null

            let answerVal = 
                isCPAnswerSheet && Boolean(answer) ?  
                    answer :
                Boolean(answer) ? answer._id : null

            let answerPts = Boolean(state.prediction) &&
                      Boolean(state.prediction.filter((p) => p.stage === 'questionnaire' && p.qid === q.qid)[0]) ?
                        state.prediction.filter((p) => p.stage === 'questionnaire' && p.qid === q.qid)[0].pts :
                        null

            return (
            <Accordion key={q.qid} expanded={expanded === q.qid} onChange={e => handleAccordionChange(q.qid)}>
                <AccordionSummary id={q.qid} 
                    sx={{py:1.5, 
                      color: [CORRECTQUESTIONNAIRE, 0].includes(answerPts) ? theme.palette.primary.contrastText : theme.palette.grey[900],
                      backgroundColor: 
                        !isNaN(answerPts) && answerPts === CORRECTQUESTIONNAIRE ?
                            theme.palette.success.main :
                        !isNaN(answerPts) && answerPts === 0 ?
                            theme.palette.error.main :
                        theme.palette.grey[50]}}>
                    <Typography sx={{ width: '80%', flexShrink: 0, marginRight: 'auto', fontSize: isSmUp ? '15px' : '13px' }} className={"boldest"}>
                        {i + 1}.&nbsp;&nbsp;{q.question}
                    </Typography>
                    <Typography>
                        {Boolean(answer) ? 
                            <span>{answerAv}</span>
                            : '.......'}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box sx={{py:2, px: 2}}>
                        <Typography sx={{fontSize: isSmUp ? '15px' : '13px'}}>
                            {q.hint}
                        </Typography>
                        <Box sx={{my:4}}>
                            {['select-team'].includes(q.answerCategory) ?
                                <SelectAdvanced 
                                type="team"
                                value={answerVal}
                                answerOptions={q.answerOptions}
                                handleChangeValue={handleChangeValue}
                                />
                            :''}
                        </Box>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center"
                        sx={{mb:2}}>
                            <Grid item>
                                <Button style={{marginRight: 'auto'}}
                                disabled={i < 1} onClick={e => handleAccordionChange('q' + (i))}>
                                    <FontAwesomeIcon icon={faArrowLeft} />&nbsp;&nbsp;Back
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" disableElevation
                                /*disabled={(i+1) === state.questions.length}*/ onClick={e => handleAccordionChange('q' + ((i+1) === state.questions.length ? "X" : (i+2)))}>
                                    Save{(i+1) !== state.questions.length ? " & Proceed" : ""}&nbsp;&nbsp;<FontAwesomeIcon icon={(i+1) !== state.questions.length ? faArrowRight : faCheck} />
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </AccordionDetails>
            </Accordion>
            )
        })}
    </div>
  );
}